<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 0;padding-bottom: 0">
      <el-form :model="form" class="com-search-box" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="图书名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入图书名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="图书编号 :" prop="bookNo">
              <el-input v-model="form.bookNo" placeholder="请输入图书编号"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="领取书名" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="apply_time" label="申请时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="receive_time" label="领书时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="book_no" label="领取图书编号" min-width="7%"></el-table-column>
          <el-table-column prop="borrow_num" label="领取数量" min-width="7%"></el-table-column>
          <el-table-column label="状态" min-width="7%">
            <template slot-scope="scope">{{ scope.row.status | filterStatus }}</template>
          </el-table-column>
          <el-table-column  label="是否逾期" min-width="7%">
            <template slot-scope="scope">{{scope.row.deferred_status == 1? '已逾期': '否'}}</template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <a class="m-btn mr-10 m-danger" v-if="scope.row.status == 0" @click="deleteBook(scope.row.id)">删除</a>
              <a class="m-btn mr-10" v-else-if="scope.row.status == 1" @click="cancelApply(scope.row.id)">取消申请</a>
              <a class="m-btn mr-10" v-else-if="scope.row.status == 2" @click="receive(scope.row.id)">我已领取</a>
              <a class="m-btn mr-10" v-else-if="scope.row.status == 3" @click="reapply(scope.row.id)">重新申请</a>
              <a class="m-btn mr-10 c-d" v-else>-</a>
              <!-- <a class="m-btn mr-10" @click="handleInterView( scope.row.id)">编辑</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      that: this,
      form: {
        name: '',
        bookNo: '',
        type: 2
      },
      listLoading: true,
      tableData: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
    }
  },

  filters: {
    filterStatus(status) {
      switch (status) {
        case 0:
          return '已取消'
        case 1:
          return '待审批'
        case 2:
          return '未领取'
        case 3:
          return '已拒绝'
        case 4:
          return '已领取'
      }
    }
  },

  methods: {
    initData() {
      this.listLoading = true
      this.$api.book.getEmployeePageList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total

        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })

    },

    // 详情
    showDetail(item) {
    },

    getTableList() {
      this.listQuery.currentPage = 1
      this.initData()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },


    restList(formName) {
      this.$refs[formName].resetFields();
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    deleteBook(id) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.delBook({ id: id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    //取消申请
    cancelApply(id) {
      this.$common.confirm(
        {
          title: `是否取消申请？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.cancelApply({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('成功取消')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    reapply(id) {
      this.$common.confirm(
        {
          title: `是否重新申请借阅？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.reapply({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('重新申请成功')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    receive(id) {
      this.$common.confirm(
        {
          title: `是否已领书？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.receive({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('成功领书')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

  },

  mounted() {
    this.initData()
    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.com-search-box {
  /deep/ .el-col {
    margin-bottom: 30px;
  }
}
</style>